import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, CalendarDays, MapPin } from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/public/Bits";
import { MediaDisplay } from "@/components/MediaDisplay";

export default function EventDetail() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/public/events/${id}`).then((r) => setItem(r.data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-24 text-center">
        <h1 className="font-serif text-3xl font-bold text-ukf-ink">Event not found</h1>
        <Link to="/events" className="mt-4 inline-block text-ukf-red hover:underline">← Back to Events</Link>
      </div>
    );
  }
  if (!item) return <Loader />;

  return (
    <article className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8" data-testid="event-detail">
      <Link to="/events" data-testid="event-back-link" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 transition-colors hover:text-ukf-red">
        <ArrowLeft className="h-4 w-4" /> All Events
      </Link>
      <h1 className="mt-8 pt-2 font-serif text-4xl font-bold leading-[1.3] tracking-tight text-ukf-ink">{item.name}</h1>
      <div className="ukf-gold-rule mt-5" />
      <div className="mt-6 flex flex-wrap gap-6 text-sm text-slate-600">
        <span className="flex items-center gap-2">
          <CalendarDays className="h-4 w-4 text-ukf-gold-dark" />
          {new Date(item.date).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
        </span>
        {item.location && <span className="flex items-center gap-2"><MapPin className="h-4 w-4 text-ukf-gold-dark" /> {item.location}</span>}
      </div>
      {item.description?.trim() && (
        <p className="mt-8 whitespace-pre-line text-base leading-relaxed text-slate-700">{item.description}</p>
      )}
      {item.media?.length > 0 && (
        <div className="mt-10 border-t border-slate-200 pt-8">
          <h2 className="mb-5 font-mono text-xs font-semibold uppercase tracking-wider text-ukf-red">Attachments</h2>
          <MediaDisplay media={item.media} />
        </div>
      )}
    </article>
  );
}
